import { OutdoorType } from 'core/creative/Creative';
import { OutdoorCreativeFields } from 'core/creative/OutdoorCreative';
import { useMemo } from 'react';

export const useOutdoorProperties = (values: OutdoorCreativeFields) => {
  const outdoorType = values.typeProperties.outdoorType;
  const creativeSize = values.typeProperties.creativeSize;
  const [width, height] = useMemo(
    () => (creativeSize ? creativeSize.split('x').map((value) => +value) : []),
    [creativeSize]
  );

  return {
    width,
    height,
    creativeSize,
    duration: values.typeProperties.duration,
    outdoorType: values.typeProperties.outdoorType,
    // 這裡刻意不用 isImageAudioFamily()：outdoorType 是 typeProperties 的 discriminant
    // 別名，直接比較才會讓 TS 收窄到帶 useAudio 的那個 union 成員；包成函式呼叫就收窄
    // 不到（TS2339）。純圖片（IMAGE）與「圖+音」同一個成員，故兩個值都要列。
    useAudio:
      outdoorType === OutdoorType.IMAGE_AUDIO ||
      outdoorType === OutdoorType.IMAGE
        ? values.typeProperties.useAudio
        : undefined
  };
};
